import { gql } from "@apollo/client";

// 🔹 GET ALL EVENTS (simplified - removed problematic nested relationships) 
export const GET_ALL_EVENTS = gql`
  query GetAllEvents(
    $limit: Int = 50
    $offset: Int = 0
    $orderBy: [events_order_by!]
    $searchText: String = "%%"
  ) {
    events(
      where: {
        _and: [
          { e_name: { _ilike: $searchText } }
          { e_deleted_at: { _is_null: true } }
          { e_status: { _neq: "closed" } }
        ]
      }
      order_by: $orderBy
      limit: $limit
      offset: $offset
    ) {
      e_id
      e_name
      e_date
      e_is_active
      e_status
      e_platform_name
      e_state
      e_address
      e_city
      e_state
      e_time
      event_categories(limit: 1) {
        league_category {
          league {
            l_name
          }
        }
      }
    }
    events_aggregate(
      where: {
        _and: [
          { e_name: { _ilike: $searchText } }
          { e_deleted_at: { _is_null: true } }
          { e_status: { _neq: "closed" } }
        ]
      }
      limit: 50
    ) {
      aggregate {
        count
      }
    }
  }
`;

// 🔹 UPDATE EVENT STATUS
export const UPDATE_EVENT_STATUS = gql`
  mutation UpdateEventStatus($e_id: uuid!, $e_is_active: Boolean!, $e_status: String!) {
    update_events_by_pk(
      pk_columns: { e_id: $e_id }
      _set: { e_is_active: $e_is_active, e_status: $e_status }
    ) {
      e_id
      e_is_active
      e_status
      e_name
    }
  }
`;


// 🔹 UPDATE EVENT (full edit)
export const UPDATE_EVENT = gql`
  mutation UpdateEvent($e_id: uuid!, $eventData: events_set_input!) {
    update_events_by_pk(pk_columns: { e_id: $e_id }, _set: $eventData) {
      e_id
      e_name
      e_date
      e_time
       e_is_active,
     
    }
  }
`;

// 🔹 ADD NEW EVENT
export const ADD_EVENT = gql`
mutation AddEvent($eventInput: events_insert_input!) {
  insert_events_one(object: $eventInput) {
    e_id
    e_name
    e_date
    e_city
    e_state
    e_address 
    e_is_active
    e_time
    e_status
  }
}
`;
export const GET_ALL_LEAGUES = gql`
  query GetAllLeagues {
    leagues(
      where: {
        l_is_active: { _eq: true }
        l_deleted_at: { _is_null: true }
      }
      order_by: { l_name: asc }
    ) {
      l_id
      l_name
      l_type
    }
  }
`;

// 🔹 DELETE EVENT
export const DELETE_EVENT = gql`
  mutation DeleteEvent($e_id: uuid!) {
    delete_events_by_pk(e_id: $e_id) {
      e_id
      e_name
    }
  }
`;

// 🔹 SEARCH VENUES (for autocomplete)
export const SEARCH_VENUES = gql`
  query SearchVenues($searchText: String = "%%") {
    events(
      where: {
        _and: [
          { e_address: { _ilike: $searchText } }
          { e_deleted_at: { _is_null: true } }
        ]
      }
      distinct_on: e_address
      order_by: { e_address: asc }
      limit: 10
    ) {
      e_address
    }
  }
`;
